import React, { useCallback, useRef, useState } from "react";
import { Popup } from "devextreme-react/popup";
import { NumberBox } from "devextreme-react";
import { confirm } from "devextreme/ui/dialog";
import { MESSAGES } from "../../../../../common/Messages";
import { OperationDialogFooter } from "./OperationDialogParts";

// uOMD0029 edtDiscountPercentage DisplayFormat ',0.00;,0.00-': two decimals, negatives allowed.
const DISCOUNT_FORMAT = "#,##0.00";

/**
 * Legacy uOMD0029 "Reset Item Discount" dialog: asks for the discount percent to put on every detail line.
 * Presentational only — the caller runs the reset, and the server decides whether the order allows it,
 * the same way AutoSelectLotsPopup (OMD0015) is wired.
 */
function ResetItemDiscountPopup({ visible, onClose, onApply }) {
    const [discountPercent, setDiscountPercent] = useState(0);
    const discountRef = useRef(null);

    // Delphi created the form on every call, so the field starts at zero each time.
    const close = useCallback(() => {
        setDiscountPercent(0);
        onClose();
    }, [onClose]);

    // uOMD0029 BitBtn1Click: a zero discount needs a Yes before it overwrites every line.
    const handleOk = useCallback(async () => {
        const discount = discountPercent ?? 0;
        if (discount === 0 && !(await confirm(MESSAGES.RESET_ITEM_DISCOUNT_ZERO_CONFIRM, MESSAGES.CONFIRM))) {
            return;
        }
        close();
        onApply(discount);
    }, [discountPercent, close, onApply]);

    return (
        <Popup
            visible={visible}
            onHiding={close}
            onShown={() => discountRef.current?.instance()?.focus()}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showTitle={true}
            title={MESSAGES.RESET_ITEM_DISCOUNT_TITLE}
            width={360}
            height="auto"
            showCloseButton={true}
        >
            <div style={{ padding: "4px 8px 8px 8px" }}>
                <div className="text-muted" style={{ paddingBottom: 10 }}>
                    {MESSAGES.RESET_ITEM_DISCOUNT_HINT}
                </div>
                <NumberBox
                    ref={discountRef}
                    label="Item Discount"
                    labelMode="static"
                    stylingMode="outlined"
                    value={discountPercent}
                    format={DISCOUNT_FORMAT}
                    showSpinButtons={true}
                    onValueChanged={(e) => setDiscountPercent(e.value ?? 0)}
                />
                <OperationDialogFooter onOk={handleOk} onCancel={close} />
            </div>
        </Popup>
    );
}

export default ResetItemDiscountPopup;
